// Same base URL jo pressCoverageApi.js / eventsApi.js mein already hai
const API_BASE = "https://assocham.org/api";

// Agar kisi state ka DB slug route-slug se alag hai, yahan map kar do.
// Key = React route slug (jo App.jsx mein hai), Value = DB me actual slug
const SLUG_OVERRIDES = {
  // "andhra-pradesh": "andhra-pradesh-state-development-council",
  // "jammu-kashmir": "jk-state-development-council",
};

export async function getRegionBySlug(slug) {
  if (!slug) return null;
  const dbSlug = SLUG_OVERRIDES[slug] || slug;

  try {
    const res = await fetch(`${API_BASE}/get_region.php?slug=${encodeURIComponent(dbSlug)}`);
    const json = await res.json();

    if (!json.success) return null;
    return json.data;
  } catch (err) {
    console.error("getRegionBySlug error:", err);
    return null;
  }
}